import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { AIDesigner } from './components/AIDesigner';
import { LiveDashboard } from './components/LiveDashboard';
import { Problem } from './components/Problem';
import { BeforeAfter } from './components/BeforeAfter';
import { Solution } from './components/Solution';
import { HowItWorks } from './components/HowItWorks';
import { ContentPartners } from './components/ContentPartners';
import { IntelligenceEngine } from './components/IntelligenceEngine';
import { Features } from './components/Features';
import { UseCases } from './components/UseCases';
import { Reporting } from './components/Reporting';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { CTA } from './components/CTA';
import { StatsBand } from './components/StatsBand';
import { AudienceSelector } from './components/AudienceSelector';
import { SocialProof } from './components/SocialProof';
import { ComparisonTable } from './components/ComparisonTable';
import { DesignerFlow } from './components/designer/DesignerFlow';
import { ReportPage } from './components/report/ReportPage';
import { DashboardPage } from './components/dashboard/DashboardPage';
import { DashboardDesignerPage } from './components/dashboard/DashboardDesignerPage';
import { EventsPage } from './components/dashboard/EventsPage';
import { AttendeesPage } from './components/dashboard/AttendeesPage';
import { AgendaPage } from './components/dashboard/AgendaPage';
import { LearningPage } from './components/dashboard/LearningPage';
import { GroupsPage } from './components/dashboard/GroupsPage';
import { SurveysPage } from './components/dashboard/SurveysPage';
import { ReportsPage } from './components/dashboard/ReportsPage';
import { SettingsPage } from './components/dashboard/SettingsPage';
import { EventHubPage } from './components/dashboard/EventHubPage';
import { ClientBookPage } from './components/dashboard/clients/ClientBookPage';
import { ClientUploadPage } from './components/dashboard/clients/ClientUploadPage';
import { ClientDetailPage } from './components/dashboard/clients/ClientDetailPage';
import { ProposalBuilderPage } from './components/dashboard/clients/ProposalBuilderPage';
import { SalesSheet } from './components/salesSheet/SalesSheet';
import { ForDMCsPage } from './components/forDMCs/ForDMCsPage';
import { ForHotelsPage } from './components/forHotels/ForHotelsPage';
import { ForFacilitatorsPage } from './components/forFacilitators/ForFacilitatorsPage';
import { ForHRPage } from './components/forHR/ForHRPage';
import { ForMICEPlannersPage } from './components/forMICE/ForMICEPlannersPage';
import { ForHealthClubsPage } from './components/forHealthClubs/ForHealthClubsPage';
import { PartnerOverviewPage } from './components/partnerPortal/PartnerOverviewPage';
import { BookAnalyzerPage } from './components/partnerPortal/BookAnalyzerPage';
import { PipelinePage } from './components/partnerPortal/PipelinePage';
import { PartnerProposalBuilderPage } from './components/partnerPortal/PartnerProposalBuilderPage';
import { PerformancePage } from './components/partnerPortal/PerformancePage';
import { InvestorDeckPage } from './components/decks/InvestorDeckPage';
import { LamplighterDeckPage } from './components/decks/LamplighterDeckPage';
import { PRDPage } from './components/prd/PRDPage';
import { OffsiteOverviewPage } from './components/clientPortal/OffsiteOverviewPage';
import { DiagnosticIntakePage } from './components/clientPortal/DiagnosticIntakePage';
import { OffsiteBriefPage } from './components/clientPortal/OffsiteBriefPage';
import { AgendaBuilderPage } from './components/clientPortal/AgendaBuilderPage';
import { DeliverablesCenterPage } from './components/clientPortal/DeliverablesCenterPage';
import { OutcomesDashboardPage } from './components/clientPortal/OutcomesDashboardPage';
import { HubOverviewPage } from './components/participantHub/HubOverviewPage';
import { FlightPackPage } from './components/participantHub/FlightPackPage';
import { ArrivalBriefingPage } from './components/participantHub/ArrivalBriefingPage';
import { LiveCompanionPage } from './components/participantHub/LiveCompanionPage';
import { KnowledgeStudioPage } from './components/participantHub/KnowledgeStudioPage';
import { ActionPlanPage } from './components/participantHub/ActionPlanPage';
import { HitecPage } from './components/hitec/HitecPage';
function ScrollToTop() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      // Allow hash anchors (#section) to scroll naturally
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        return;
      }
    }
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
  }, [pathname, hash]);
  return null;
}
function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-800" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <StatsBand data-id="element-4" />
        <AIDesigner data-id="element-5" />
        <LiveDashboard data-id="element-6" />
        <AudienceSelector data-id="element-7" />
        <Problem data-id="element-8" />
        <BeforeAfter data-id="element-9" />
        <Solution data-id="element-10" />
        <ContentPartners data-id="element-11" />
        <HowItWorks data-id="element-12" />
        <IntelligenceEngine data-id="element-13" />
        <Features data-id="element-14" />
        <ComparisonTable data-id="element-15" />
        <UseCases data-id="element-16" />
        <Reporting data-id="element-17" />
        <SocialProof data-id="element-18" />
        <Pricing data-id="element-19" />
        <FAQ data-id="element-20" />
      </main>
      <CTA data-id="element-21" />
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-22">
      <ScrollToTop data-id="element-23" />
      <Routes data-id="element-24">
        <Route path="/" element={<LandingPage data-id="element-26" />} data-id="element-25" />
        <Route path="/demo" element={<LandingPage data-id="element-28" />} data-id="element-27" />
        <Route path="/hitec" element={<HitecPage data-id="element-30" />} data-id="element-29" />
        <Route path="/designer" element={<DesignerFlow data-id="element-32" />} data-id="element-31" />
        <Route path="/report" element={<ReportPage data-id="element-34" />} data-id="element-33" />
        <Route path="/dashboard" element={<DashboardPage data-id="element-36" />} data-id="element-35" />
        <Route path="/dashboard/designer" element={<DashboardDesignerPage data-id="element-38" />} data-id="element-37" />
        <Route path="/event-hub" element={<EventHubPage data-id="element-40" />} data-id="element-39" />
        <Route path="/dashboard/events" element={<EventsPage data-id="element-42" />} data-id="element-41" />
        <Route path="/dashboard/attendees" element={<AttendeesPage data-id="element-44" />} data-id="element-43" />
        <Route path="/dashboard/agenda" element={<AgendaPage data-id="element-46" />} data-id="element-45" />
        <Route path="/dashboard/learning" element={<LearningPage data-id="element-48" />} data-id="element-47" />
        <Route path="/dashboard/groups" element={<GroupsPage data-id="element-50" />} data-id="element-49" />
        <Route path="/dashboard/surveys" element={<SurveysPage data-id="element-52" />} data-id="element-51" />
        <Route path="/dashboard/reports" element={<ReportsPage data-id="element-54" />} data-id="element-53" />
        <Route path="/dashboard/clients" element={<ClientBookPage data-id="element-56" />} data-id="element-55" />
        <Route path="/dashboard/clients/upload" element={<ClientUploadPage data-id="element-58" />} data-id="element-57" />
        <Route path="/dashboard/clients/:id" element={<ClientDetailPage data-id="element-60" />} data-id="element-59" />
        <Route path="/dashboard/proposals/new" element={<ProposalBuilderPage data-id="element-62" />} data-id="element-61" />
        <Route path="/dashboard/settings" element={<SettingsPage data-id="element-64" />} data-id="element-63" />
        <Route path="/sales-sheet" element={<SalesSheet data-id="element-66" />} data-id="element-65" />
        <Route path="/for-dmcs" element={<ForDMCsPage data-id="element-68" />} data-id="element-67" />
        <Route path="/for-hotels" element={<ForHotelsPage data-id="element-70" />} data-id="element-69" />
        <Route path="/for-facilitators" element={<ForFacilitatorsPage data-id="element-72" />} data-id="element-71" />
        <Route path="/for-hr" element={<ForHRPage data-id="element-74" />} data-id="element-73" />
        <Route path="/for-mice" element={<ForMICEPlannersPage data-id="element-76" />} data-id="element-75" />
        <Route path="/for-planners" element={<ForMICEPlannersPage data-id="element-78" />} data-id="element-77" />
        <Route path="/for-health-clubs" element={<ForHealthClubsPage data-id="element-80" />} data-id="element-79" />

        {/* Partner Portal Routes */}
        <Route path="/partner-portal" element={<PartnerOverviewPage data-id="element-82" />} data-id="element-81" />
        <Route path="/partner-portal/book-analyzer" element={<BookAnalyzerPage data-id="element-84" />} data-id="element-83" />
        <Route path="/partner-portal/pipeline" element={<PipelinePage data-id="element-86" />} data-id="element-85" />
        <Route path="/partner-portal/proposals" element={<PartnerProposalBuilderPage data-id="element-88" />} data-id="element-87" />
        <Route path="/partner-portal/performance" element={<PerformancePage data-id="element-90" />} data-id="element-89" />

        {/* Pitch Decks */}
        <Route path="/investor-deck" element={<InvestorDeckPage data-id="element-92" />} data-id="element-91" />
        <Route path="/lamplighter-deck" element={<LamplighterDeckPage data-id="element-94" />} data-id="element-93" />

        {/* Product Requirements Doc */}
        <Route path="/prd" element={<PRDPage data-id="element-96" />} data-id="element-95" />

        {/* Client Portal */}
        <Route path="/client-portal" element={<OffsiteOverviewPage data-id="element-98" />} data-id="element-97" />
        <Route path="/client-portal/diagnostic" element={<DiagnosticIntakePage data-id="element-100" />} data-id="element-99" />
        <Route path="/client-portal/brief" element={<OffsiteBriefPage data-id="element-102" />} data-id="element-101" />
        <Route path="/client-portal/agenda" element={<AgendaBuilderPage data-id="element-104" />} data-id="element-103" />
        <Route path="/client-portal/deliverables" element={<DeliverablesCenterPage data-id="element-106" />} data-id="element-105" />
        <Route path="/client-portal/outcomes" element={<OutcomesDashboardPage data-id="element-108" />} data-id="element-107" />

        {/* Participant Experience Hub */}
        <Route path="/experience-hub" element={<HubOverviewPage data-id="element-110" />} data-id="element-109" />
        <Route path="/experience-hub/flight-pack" element={<FlightPackPage data-id="element-112" />} data-id="element-111" />
        <Route path="/experience-hub/arrival" element={<ArrivalBriefingPage data-id="element-114" />} data-id="element-113" />
        <Route path="/experience-hub/live" element={<LiveCompanionPage data-id="element-116" />} data-id="element-115" />
        <Route path="/experience-hub/knowledge" element={<KnowledgeStudioPage data-id="element-118" />} data-id="element-117" />
        <Route path="/experience-hub/action-plan" element={<ActionPlanPage data-id="element-120" />} data-id="element-119" />
      </Routes>
    </BrowserRouter>;
}